import { render, staticRenderFns } from "./ConfigType.vue?vue&type=template&id=25a4b138&scoped=true&"
import script from "./ConfigType.vue?vue&type=script&lang=js&"
export * from "./ConfigType.vue?vue&type=script&lang=js&"
import style0 from "./ConfigType.vue?vue&type=style&index=0&id=25a4b138&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a4b138",
  null
  
)

export default component.exports